import React, { useContext, useState } from 'react';
import { Modal, Button } from 'edcom-ui';
import GDPRContext from '../../../services/GDPRContext';
import AccountContext from '../../../services/AccountContext';
import gdprModalStyle from './GDPRModal.module.less';

export default function GDPRModal() {
  const { inGDPR } = useContext(GDPRContext);
  const { logout } = useContext(AccountContext);
  const [open, setOpen] = useState(false);
  const loggedIn = false;

  if (!inGDPR) return null;

  const description = loggedIn
    ? 'Warning - you will be logged out if you decide to disable cookies. You must re-enable cookies in order to log back into your account.'
    : 'Warning - you are about to disable cookies. If you decide to create an account with us in the future, you will need to enable cookies before doing so.';

  const removeAllCookies = () => {
    const cookie = document.cookie;
    if (!cookie) return;

    const cookieArray = cookie.split('; ');
    cookieArray.forEach(cookieString => {
      const c = cookieString.split('=');
      document.cookie = `${c[0]}=; path=/; domain=.education.com; max-age=; expires=; secure=; samesite=`;
    });
  };

  const handleClickOptOut = () => {
    removeAllCookies();
    setOpen(false);
    logout();
  };

  return (
    <>
      <a onClick={() => setOpen(true)}>Disable cookies</a>
      <Modal open={open} onClose={() => setOpen(false)}>
        <h3>Disable Cookies</h3>
        <p>{description}</p>
        <Button className={gdprModalStyle.button} onClick={handleClickOptOut}>
          Opt Out
        </Button>
      </Modal>
    </>
  );
}
